module.exports = __webpack_public_path__ + "71ba6962a8711359f5345d532f242a43.jpg";